import React from "react";
import { Box, Pagination, Select, MenuItem, Typography } from "@mui/material";

const CustomPagination = ({
  page,
  count,
  limit,
  onPageChange,
  onLimitChange,
  limitOptions = [10, 20, 50],
}) => {
  const handleLimitChange = (value) => {
    onLimitChange?.(Number(value));
  };

  return (
    <Box
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      gap={2}
      py={2}
    >
      <Box display="flex" alignItems="center" gap={1}>
        <Typography variant="body2">Rows per page:</Typography>
        <Select
          size="small"
          value={String(limit)}
          onChange={(e) => handleLimitChange(e.target.value)}
          sx={{
            height: 32,
            fontSize: 13,
            "& .MuiSelect-select": {
              py: 0.5,
            },
          }}
        >
          {limitOptions.map((opt) => (
            <MenuItem key={opt} value={String(opt)}>
              {opt}
            </MenuItem>
          ))}
        </Select>
      </Box>

      <Pagination
        count={count}
        page={page}
        onChange={onPageChange}
        color="primary"
        shape="rounded"
      />
    </Box>
  );
};

export default CustomPagination;
